import React from "react"
import styled from "styled-components"

import responsive from "@styles/responsive"

const Card = ({ children }) => (
  <Container className="is-card">{children}</Container>
)

export default Card

const Container = styled.div`
  background: ${props => props.theme.colors.background};
  border-radius: 4px;
  color: ${props => props.theme.colors.paragraph};
  ${props => props.theme.mixins.boxShadow};
  padding: 3.2rem;
  margin-bottom: 2rem;

  ${responsive.sm} {
    padding: 2rem;
  }
`
